import React from "react";
import { Button, Modal } from "react-bootstrap";

const PaymentConfirmedModal = ({ title, amount, date, show, updateModalShow, resetValues, isScheduled, isAutopay }) => {
  return (
    <Modal
      show={show}
      onHide={() => {
        updateModalShow(false);
      }}
      className="modal-style-1 w-100"
      size="md"
    >
      <Modal.Header>
        <Modal.Title as="h3" className="w-100 text-center">
          {title}
        </Modal.Title>
      </Modal.Header>

      {/* ARR-1417 - adjusted modal body to reflect Tenant Payment Notice 24 Hours to Withdraw from Bank Account */}

      <Modal.Body>
        <div className="text-center">
          <p className="card-title mb-3"> 
            Your payment may take 24 hours to withdraw from your bank account. If you have any questions regarding
            payments please email support@arrivo.ai
          </p>
          <p className="card-title">Your payment of</p>
          <span className="mt-1" style={{ fontSize: "24px", display: "block"}}>
            <strong>{amount}</strong>
          </span>
          <p className="card-title mt-3">{isScheduled ? "Is scheduled for" : "Was initiated on"}</p>
          <span style={{ fontSize: "24px" , display: "block"}}>
            <strong>{date}</strong>
          </span>
          {isAutopay && (
            <p className="card-title mt-4">
              This payment amount will be automatically debited from your account the same day each month.
            </p>
          )}
        </div>
      </Modal.Body>
      <Button
        onClick={() => {
          resetValues();
          updateModalShow(false);
        }}
        className="mt-4"
      >
        Okay
      </Button>
    </Modal>
  );
};
export default PaymentConfirmedModal;
